import { API_ENDPOINT } from '../../../constants';

export const ONBOARDING_QUESTIONNAIRES_API_BASE = `${API_ENDPOINT}/onboarding_questionnaires`;
